import { useContext, useMemo } from 'react';

import './CustomerLeadStepGuide.scss';

import { HtmlPreview } from 'src/components/base/HtmlPreview';
import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';

export function CustomerLeadStepGuide() {
  const { customerLeadProductSpecification, customerStepGuideKey } = useContext(CustomersContext);

  const htmlContent = useMemo(
    () =>
      (customerStepGuideKey && customerLeadProductSpecification?.fieldGroupGuides[customerStepGuideKey]) ?? undefined,
    [customerStepGuideKey, customerLeadProductSpecification?.fieldGroupGuides]
  );

  return (
    <div className="customer-lead-step-guide__container">
      <HtmlPreview content={htmlContent} className="customer-lead-step-guide__preview" />
    </div>
  );
}
